<div class="copyright">
  <small>{{'COMMON.copyright' | translate: null: currentYear}}</small>
</div>
